import { isProduction } from '@quadminds/shared/utils';
import LogRocket from 'logrocket';
import { useEffect } from 'react';

type IUserTraits = {
    [propName: string]: string | number | boolean;
};

type StandardTraits = {
    email?: string;
    firstName?: string;
    lastName?: string;
    appDomain?: string;
};

export const useLogRocket = (identifier?: string, trackBody?: IUserTraits | StandardTraits | null) => {
    useEffect(() => {
        // If no identifier supplied, return
        if (!identifier || !isProduction()) return;
        if (process.env['NX_DISABLE_SESSION_RECORDINGS'] === 'true') return;
        if (typeof LogRocket === 'undefined' || typeof LogRocket.init !== 'function') return;
        // Identify user session
        const traits: IUserTraits | StandardTraits = { ...trackBody };
        if (!trackBody?.appDomain) {
            traits.appDomain = window.location.href;
        }
        LogRocket.identify(identifier, traits);
    }, [identifier, trackBody]);
};
